import { render, staticRenderFns } from "./ValidationListCommunication.vue?vue&type=template&id=2350029b&"
import script from "./ValidationListCommunication.vue?vue&type=script&lang=js&"
export * from "./ValidationListCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports